import React from 'react'

import { type Question, useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'

import { buildMatrixSubQuestions } from '../utils'

export const useSubQuestions = (question: Question | null | undefined) => {
  const questions = useSurveyQueryQuestions()

  return React.useMemo(
    () => buildMatrixSubQuestions(questions, question),
    [question, questions],
  )
}
